import {SODeleteAttachment} from '../../core/attachment/so-delete-attachment';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteAttachment extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteAttachment;
}